import Vue from 'vue'

export default {
    data() {
        return {
            //Landing Page Images - 2018/03/23 - Onesi
            main_bg_image: '../../../static/assets/img/KidImages/Portal Photo_KidImage3.jpeg',
            portal_benefits_img: '../../../../static/assets/img/DoctorImages/Portal Photo_DoctorImage4.jpg',
            portal_requirements_img: '../../../../static/assets/img/DoctorImages/Portal Photo_DoctorImage2.jpeg',
            blue_bg: '../static/assets/img/bg/bg-img1.png',
            cycle_of_giving_img: '../../../../static/assets/img/cycle_of_giving.png',

            //Landing Page Icons - 2018/03/23 - Onesi
            learn_icon: '../../../../static/assets/img/icons/Landing Page Icons/OSEL_Foundation_white_vertical.png',
            discover_icon: '../../../../static/assets/img/icons/Landing Page Icons/Discover_More_400x400.png',
            contact_portal_icon: '../../../../static/assets/img/icons/Landing Page Icons/Mail_400x400.png',

            //Landing Page Logo - 2018/07/03 - Marc
            cltl_logo_blue: '../../../../static/assets/img/logo/cltl_logo_blue.png',
            cltl_logo_white:  '../../../../static/assets/img/logo/ChampionForSight_Badge-White.png',

            //Home Page Images - 2018-03-23 - Onesi
            covidrelief_banner_miss_img: '../../../../static/assets/img/miss_doctor.png',
            covidrelief_banner_mister_img: '../../../../static/assets/img/mister_doctor_2.png',
            home_banner_img: '../../../../static/assets/img/home_banner_champions_for_sight.png',
            CNN_Top_Left: '../../../../static/img/TopLeftCNN.png',
            CNN_Top_Right: '../../../../static/img/BottomLeftCNN2.jpg',
            CNN_Bottom_Left: '../../../../static/assets/img/CLTLDay/AdobeStock_103567562_Edit.jpg',
            CNN_Bottom_Right: '../../../../static/img/BottomRightCNN.png',
            colleague_bg: '../../../static/assets/img/bg/Phoropter_1.jpeg',
            success_story_1: '../../../../static/assets/img/FamilyImages/portal Photo_Family2.jpg',
            success_story_2: '../../../../static/assets/img/DoctorImages/Portal Photo_DoctorImage5.jpg',
            success_story_3: '../../../../static/assets/img/FamilyImages/portal Photo_FamilyImage5.jpg',

            //Sucess Story Loader Image
            story_wufoo_loader: '../../../../static/img/loading.gif',

            //Home Page Links - 2018/03/23 - Onesi
            info_share_link: '../../../../static/resources/EVF_PortalFlyer_March2018.pdf',

            //Frame Page Images - 2018/03/26 - Onesi
            frame_banner_img: '../../../../../static/assets/img/FamilyImages/portal Photo_FamilyImage 3.jpeg',
            charitable_outreach_img: '../../../../../static/assets/img/E43A3409.jpg',

            //Account Type Hover Text
            invAccountTooltip: "This account is for eye doctors who want to submit orders for charitable work done independent of their practice or through a charitable referral network.",
            businessAccountTooltip: "This account is for a business to submit charitable work done through their practice.  This will cover all eye doctors working on behalf of this business.",
            nonprofitAccountTooltip: "This account is for non-profits to submit orders for charitable glasses. This is only for non-profits who serve directly, not those who operate as a referral network and do not place orders for glasses directly.",

            //Registration Hover Text
            relationshipTooltip: "Please select the affiliation the doctor has with the participant/account. If the doctor is not formally associated with the business or organization, select 'Unaffiliated'",
            npiTooltip: "An NPI (National Provider Identifier) is a unique 10-digit identification number issued to health care providers in the US by the Centers for Medicare and Medicaid Services (CMS). This number will only be used as a unique identifier for each doctor in our system.",
            doctorAffiliationToolTip: "Please select the affiliation the doctor has with the participant/account. If the doctor is not formally associated with the business or organization, select 'Unaffiliated'",
            businessTypeTooltip: "Please select the choice which most closely aligns with your business.",
            organizationTypeTooltip: "Please select the choice which most closely aligns with your organization.",
            pledgeTooltip: "Please provide a best estimate. You can modifiy your estimate on the My Account page after Registration.",
            hipaaTooltip: "Are you a Covered Entity? For assistance in determining whether you are treated as a covered entity for purposes of HIPAA, please refer to HHS' decision-making tool located <a target='_blank' href='https://www.cms.gov/Regulations-and-Guidance/Administrative-Simplification/HIPAA-ACA/Downloads/CoveredEntitiesChart20160617.pdf'>here.</a>",
            npiForBusinessTooltip: "An NPI (National Provider Identifier) is a unique 10-digit identification number issued to health care providers in the US by the Centers for Medicare and Medicaid Services (CMS). This number will only be used as a unique identifier for each business in our system",
            //Shared Files Images
            pageLoader_img: '../../../static/img/loading.gif',

            //Temporary Sponsor Logos
            majorSponsorLogo: '',
            minorSponsorLogos: [],
            minorSponsorLogosHome: [],
            tempSponsorLogo: '../../../../../static/essilorvision/logo-black.png',
            tempSponsorLogo_H: '../../../../../static/essilorvision/logo.png',

            //Sponsor logos from SFDC
            sponsors: JSON.parse(localStorage.getItem('sponsors')),
            accountType: (localStorage.getItem("accountType") != null) ? localStorage.getItem('accountType') : 'user_',

            //International Mission Hover Text
            internationalMissionTooltip: "One-time support for a US participant of an international clinic. Not suitable for ongoing activities. Contact <a target='_blank' href='mailto:shindhe.gunputh@essilor.com?cc=email-cc@gmail.com&bcc=email-bcc@gmail.com&subject=Subject&body=Email Using Body'>2.5NVG Ready2Clip</a> for sustainable support.",

            //Shipping Address from SFDC
            shippingAddress: JSON.parse(localStorage.getItem('shippingAddress'))
        };
    },
    created() {
        var sponsorLength = 3;
        for (let index = 0; index < sponsorLength; index++) {
            this.minorSponsorLogos.push(this.tempSponsorLogo_H);
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/Tenancy.js